webpackJsonp(["conditioner10"],{

/***/ "./src/js/components/fake-select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = fakeSelect;
function fakeSelect($el, options) {
  var label = $el.querySelector('.label');
  var dropdown = $el.querySelector('select');

  label.innerHTML = dropdown.options[dropdown.selectedIndex].text;

  dropdown.addEventListener('change', function () {
    label.innerHTML = dropdown.options[dropdown.selectedIndex].text;
  });
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner10.7a7b85f97cb620784761.js